// @flow
import { put, call, takeLatest } from "redux-saga/effects";
import { SET_SECTION_STEP, SET_SECTION_STEP_SUCCESS } from "../constants";
import axios from "../../../services/api";

function* setSectionStep(data) {
  yield put({
    type: SET_SECTION_STEP_SUCCESS,
    data: data.value,
  });
}

export default function* setSectionStepSaga() {
  yield takeLatest(SET_SECTION_STEP, setSectionStep);
}
